<template>
  <div :class="{ hidden: hidden, customPagiseze: customPagiseze }" class="pagination-container">
    <div v-if="customPagiseze" class="edit">
      <!-- <span class="red"></span> -->
      <el-input v-model="customSize" maxlength="3" @blur="handleCustomSizeChange">
        <template slot="suffix">
          <div style="position: relative; top: 5px">条数/页</div>
        </template>
      </el-input>
    </div>
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="customPagiseze ? layout : `${this.layout.slice(0, 6)}sizes,${this.layout.slice(6)}`"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    customPagiseze: {
      type: Boolean,
      default() {
        return false
      }
    },
    originLimit: {
      type: Number,
      default: 10
    },
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      customSize: 0
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  mounted() {
    this.customSize = this.limit
  },
  methods: {
    handleSizeChange(val) {
      if (this.customPagiseze) return
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    // 处理input输入
    handleInput(e) {
      if (Number.isNaN(Number(e)) || Number(e) === 0) {
        this.$alert(`自定义分页数只能是正整数，将重置成初始值`, '提示', {
          confirmButtonText: '确定',
          showClose: false
        }).then(() => {
          this.$emit('update:limit', Number(this.originLimit))
        })
        return
      }
      this.$emit('update:limit', Number(e))
    },
    handleCustomSizeChange(e) {
      if (Number.isNaN(Number(e.target.value)) || Number(e.target.value) === 0) {
        this.$alert(`每页显示条数只能为正整数`, '提示', {
          confirmButtonText: '确定',
          showClose: false
        }).then(() => {
          this.$emit('update:limit', Number(this.originLimit))
          this.customSize = this.originLimit
        })
        return
      }
      this.$emit('update:limit', Number(e.target.value))
      this.$emit('pagination', { page: this.currentPage, limit: Number(e.target.value) })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss">
.pagination {
  margin: 0.5rem 0;
}
.pagination-container {
  background: #fff;
  padding: 0.5rem 0;
}
.pagination-container.hidden {
  display: none;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #004098;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #004098 !important;
}

.el-pagination.is-background {
  .btn-next,
  .btn-prev,
  .el-pager li {
    margin: 0 2px;
    min-width: 24px !important;
    background-color: transparent !important;
  }
}
.el-pagination__jump {
  margin-left: 8px !important;
}

.edit {
  width: 110px;
  padding: 2px 5px;
}
</style>
<style scoped>
.customPagiseze {
  display: flex;
  justify-content: end;
  position: relative;
}
</style>
